/* eslint-disable react/jsx-key */
import EdgeworthIcon from '@office-start/edgeworth-icon';
import React from 'react';
export var ActivityFilterKey;
(function (ActivityFilterKey) {
    ActivityFilterKey["created"] = "Created by me";
    ActivityFilterKey["mentions"] = "Mentions me";
    ActivityFilterKey["edits"] = "Edited by me";
    ActivityFilterKey["comments"] = "Comments by me";
    ActivityFilterKey["tasks"] = "Tasks assigned to me";
    ActivityFilterKey["hidden"] = "Hidden by me";
})(ActivityFilterKey || (ActivityFilterKey = {}));
export var ActivityFilterKeyToIconMap = new Map([
    [ActivityFilterKey.created, React.createElement(EdgeworthIcon, { iconName: "PersonIcon" })],
    [ActivityFilterKey.mentions, React.createElement(EdgeworthIcon, { iconName: "MentionIcon" })],
    [ActivityFilterKey.edits, React.createElement(EdgeworthIcon, { iconName: "EditIcon" })],
    [ActivityFilterKey.comments, React.createElement(EdgeworthIcon, { iconName: "CommentIcon" })],
    [ActivityFilterKey.tasks, React.createElement(EdgeworthIcon, { iconName: "TaskIcon" })],
    [ActivityFilterKey.hidden, React.createElement(EdgeworthIcon, { iconName: "EyeHideIcon" })],
]);
export var ActivityFilterKeyToFilledIconMap = new Map([
    [
        ActivityFilterKey.created,
        React.createElement(EdgeworthIcon, { iconName: "PersonIcon", filled: true }),
    ],
    [
        ActivityFilterKey.mentions,
        React.createElement(EdgeworthIcon, { iconName: "MentionIcon", filled: true }),
    ],
    [
        ActivityFilterKey.edits,
        React.createElement(EdgeworthIcon, { iconName: "EditIcon", filled: true }),
    ],
    [
        ActivityFilterKey.comments,
        React.createElement(EdgeworthIcon, { iconName: "CommentIcon", filled: true }),
    ],
    [
        ActivityFilterKey.tasks,
        React.createElement(EdgeworthIcon, { iconName: "TaskIcon", filled: true }),
    ],
    [
        ActivityFilterKey.hidden,
        React.createElement(EdgeworthIcon, { iconName: "EyeHideIcon", filled: true }),
    ],
]);
//# sourceMappingURL=ActivityFilters.js.map